<script setup lang="ts">
import { NuxtLink } from '#components'
import type { SiteBlockData, SiteBlockSettings } from '../../../types/site'

const props = defineProps<{ data: SiteBlockData, settings: SiteBlockSettings }>()

const colsClass = computed(() => ({
  2: 'sm:grid-cols-2',
  3: 'sm:grid-cols-2 lg:grid-cols-3',
  4: 'sm:grid-cols-2 lg:grid-cols-4'
}[props.data.columns ?? 3] ?? 'sm:grid-cols-2 lg:grid-cols-3'))

const isExternal = (url?: string) => !!url && /^(https?:|mailto:|tel:)/.test(url)
</script>

<template>
  <div>
    <SiteSectionHeading
      :eyebrow="data.eyebrow"
      :title="data.headline"
      class="mb-8"
    />
    <div
      v-if="data.cards?.length"
      class="grid grid-cols-1 gap-5"
      :class="colsClass"
    >
      <component
        :is="card.link_url ? NuxtLink : 'div'"
        v-for="(card, i) in data.cards"
        :key="i"
        v-bind="card.link_url ? { to: card.link_url, external: isExternal(card.link_url) } : {}"
        class="site-surface-card block overflow-hidden"
        :class="card.link_url ? 'transition hover:opacity-90' : ''"
      >
        <img
          v-if="card.image"
          :src="card.image"
          :alt="card.title"
          class="h-40 w-full object-cover"
          loading="lazy"
        >
        <div class="p-5">
          <h4 class="site-display text-lg tracking-tight">
            {{ card.title }}
          </h4>
          <p
            v-if="card.description"
            class="mt-2 text-sm text-[var(--site-muted)]"
          >
            {{ card.description }}
          </p>
          <span
            v-if="card.link_text && card.link_url"
            class="mt-3 inline-block text-sm font-semibold text-[var(--site-accent)]"
          >
            {{ card.link_text }} →
          </span>
        </div>
      </component>
    </div>
  </div>
</template>
